import {
	firstStep,
	secondStep,
	thirdStep,
	fourthStep,
	fifthStep,
	sixthStep,
	seventhStep,
} from "../../misc/customOptions";

export const steps = [
	firstStep,
	secondStep,
	thirdStep,
	fourthStep,
	fifthStep,
	sixthStep,
	seventhStep,
];
export const stepsLimit = steps.length - 1;
export const stepsStart = 0;
export const stepsLabel = [
	"Dados cadastrais",
	"Endereço",
	"Renda formal",
	"Renda Informal",
	"Número de dependentes",
	"Despesas mensais do grupo familiar",
	"Agência de Relacionamento",
];

//Valores padrão dos inputs
export const initialValues: any = {
	nomeCompleto: "",
	cpf: "",
};

export interface Inputs {
	name: string;
	cpf: string;
	purpose: string;
	reduced_name: string;
	gender: string;
	father_name: string;
	mother_name: string;
	nationality: string;
	uf: string;
	city: string;
	country: string;
	education_level: string;
	pis: string;
	identification_document: string;
	num_driver_license: string;
	first_license_date: string;
	issuing_body: string;
	pass_num: string;
	id_num: string;
	id_doc: string;
	id_number: string;
	uf_select: string;
	em_date: string;
	end_date: string;
	marital_status: string;
	ms_cp: string;
	occupation_type: string;
	i_occupation: string;
	f_occupation: string;
	inc_char: string;
	inc_type: string;
	payer_cpf: string;
	payer_cnpj: string;
	payer_name: string;
	occupation: string;
	ad_date: string;
	emplo_time_year: string;
	emplo_time_months: string;
	brute_inc: string;
	liquid_inc: string;
	inc_doc: string;
	inc_proof_date: string;
	irpf: string;
	activity_name: string;
	ac_start_date: string;
	liq_inc_month: string;
	proof_docs: string;
	proof_doc: string;
}
